export const Distance = ({ lat1, lon1, lat2, lon2, address }) => {

    if (
        lat1 === null || lat1 === undefined || isNaN(lat1) ||
        lon1 === null || lon1 === undefined || isNaN(lon1) ||
        lat2 === null || lat2 === undefined || isNaN(lat2) ||
        lon2 === null || lon2 === undefined || isNaN(lon2)
      ) {
        return (
            <div className="distance-container">
            <p className="distance-text">
              {address}
            </p>
          </div>
        );
      }
  // Función para convertir grados a radianes
  const toRadians = (deg) => {
    return deg * (Math.PI / 180);
  };

  const calculateDistance = () => {
    const R = 6371; // Radio de la Tierra en kilómetros

    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distancia en km

    return distance.toFixed(2); // Redondea a 2 decimales
  };

  const distance = calculateDistance();

  return (
    <div className="distance-container">
      <p className="distance-text">
         {distance} km -  {address}
      </p>
    </div>
  );

};